<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3"></a>
<p class="titlea">IMAGES OF WAR</p>
<h1 class="title1a">KNIGHT’S CROSS WINNERS OF THE WAFFEN SS</h1>
<p class="title11a"><span class="bold">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</span></p>
<p class="book-title">MARC RIKMENSPOEL</p>
<div class="img_containerp">
<img alt="image" src="images/Img_3_001.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?9db97dec